import { ApiService } from 'app/api/index';
import { IApplicationContext } from 'app/context/types';

export class AuthService {
	private apiService: ApiService;

	constructor(private applicationContext: IApplicationContext) {
		this.apiService = new ApiService(this.applicationContext);
	}

	/**
	 * Submit  credentials to authenticate the user
	 * @param code
	 */
	login({ email, password }: { email: string; password: string }) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(this.applicationContext.getApiConfig().AUTH.LOGIN, {
					email,
					password,
				})
				.then((res: any) => {
					resolve(res.data);
				})
				.catch(e => {
					reject(e);
				});
		});
	}

	/**
	 * Submit logout
	 */
	logout() {
		return this.apiService.invoke(
			this.applicationContext.getApiConfig().AUTH.LOGOUT,
			{},
		);
	}

	verifyResetPasswordLink(value: { adminId: number; resetToken: string }) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().AUTH
						.VERIFY_RESET_PASSWORD_LINK,
					value,
				)
				.then((res: any) => {
					resolve(res);
				})
				.catch(e => {
					reject(e);
				});
		});
	}

	resetPasswordRequest(value: { email: string; googleRecaptchaToken: string }) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().AUTH.RESET_PASSWORD_REQUEST,
					value,
				)
				.then((res: any) => {
					resolve(res);
				})
				.catch(e => {
					reject(e);
				});
		});
	}

	resetPassword(value: {
		adminId: number;
		resetToken: string;
		newPassword: string;
	}) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().AUTH.RESET_PASSWORD,
					value,
				)
				.then((res: any) => {
					resolve(res);
				})
				.catch(e => {
					reject(e);
				});
		});
	}
}
